import { AbstractControl, ValidationErrors } from '@angular/forms';

const regex = /^[a-zA-Z0-9ęóąśłżźćńĘÓĄŚŁŻŹĆŃ]([a-zA-Z0-9ęóąśłżźćń\-./\\-ĘÓĄŚŁŻŹĆŃęóąśłżźćń]{0,8}[a-zA-Z0-9ęóąśłżźćńĘÓĄŚŁŻŹĆŃ])?$/;

const StreetNumberValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = (formControl && String(formControl.value || '').trim()) || '';

  if (!value) {
    return {};
  }

  const streetNumber = !regex.test(value);

  if (!streetNumber) {
    return {};
  }

  return { streetNumber: true };
};

export default StreetNumberValidator;
